import { render, staticRenderFns } from "./MedicationGuidance.vue?vue&type=template&id=fc2de996&scoped=true&"
import script from "./MedicationGuidance.vue?vue&type=script&lang=js&"
export * from "./MedicationGuidance.vue?vue&type=script&lang=js&"
import style0 from "./MedicationGuidance.vue?vue&type=style&index=0&id=fc2de996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2de996",
  null
  
)

export default component.exports